import { c as _c } from "react/compiler-runtime";
import './honor-card-design-palette.scss';
import { useRef } from 'react';
import { Image } from '@sola/ark-core/atoms/image/image.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
export interface DesignPaletteProps {
  label: string;
  value: number;
  options: number[];
  onChange: (value: number) => void;
  /** Base URL pattern for thumbnail images. Defaults to compassionmedia CDN. */
  getThumbSrc?: (num: number) => string;
}
const defaultGetThumbSrc = (num: number) => `https://compassionmedia.com/card-maker/design-${num}.webp`;
export const DesignPalette: React.FC<DesignPaletteProps> = t0 => {
  const $ = _c(22);
  const {
    label,
    value,
    options,
    onChange,
    getThumbSrc: t1
  } = t0;
  const getThumbSrc = t1 === undefined ? defaultGetThumbSrc : t1;
  const groupRef = useRef(null);
  let t2;
  if ($[0] !== onChange || $[1] !== options || $[2] !== value) {
    t2 = e => {
      const currentIndex = options.indexOf(value);
      let nextIndex;
      if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        e.preventDefault();
        nextIndex = (currentIndex + 1) % options.length;
      } else {
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          e.preventDefault();
          nextIndex = (currentIndex - 1 + options.length) % options.length;
        } else {
          if (e.key === "Home") {
            e.preventDefault();
            nextIndex = 0;
          } else {
            if (e.key === "End") {
              e.preventDefault();
              nextIndex = options.length - 1;
            }
          }
        }
      }
      if (nextIndex != null) {
        onChange(options[nextIndex]);
        const buttons = groupRef.current?.querySelectorAll("[role=\"radio\"]");
        buttons?.[nextIndex]?.focus();
      }
    };
    $[0] = onChange;
    $[1] = options;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleKeyDown = t2;
  let t3;
  if ($[4] !== label) {
    t3 = <span className="form-label label">{label}</span>;
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== getThumbSrc || $[7] !== onChange || $[8] !== options || $[9] !== value) {
    let t5;
    if ($[11] !== getThumbSrc || $[12] !== onChange || $[13] !== value) {
      t5 = num => <button key={num} type="button" role="radio" tabIndex={value === num ? 0 : -1} className={cn("DesignPalette__thumb relative overflow-hidden p-0 bg-none cursor-pointer aspect-square", value === num && "DesignPalette__thumb--selected")} onClick={() => onChange(num)} aria-checked={value === num} aria-label={`Design ${num}`}><Image src={getThumbSrc(num)} alt={`Design ${num}`} className="DesignPalette__img block w-full h-full" width={80} height={80} sizes="80px" /></button>;
      $[11] = getThumbSrc;
      $[12] = onChange;
      $[13] = value;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    t4 = options.map(t5);
    $[6] = getThumbSrc;
    $[7] = onChange;
    $[8] = options;
    $[9] = value;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[15] !== handleKeyDown || $[16] !== label || $[17] !== t4) {
    t5 = <div ref={groupRef} className="DesignPalette__grid grid gap-snug-lg" role="radiogroup" aria-label={label} tabIndex={-1} onKeyDown={handleKeyDown}>{t4}</div>;
    $[15] = handleKeyDown;
    $[16] = label;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t3 || $[20] !== t5) {
    t6 = <div className="flex flex-col">{t3}{t5}</div>;
    $[19] = t3;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};